<template>
  <div>
    <div v-if="$route.params.type === 'hpcr_regist_status'" class="h4_block">
      <HpcrRegister />
      <CheckboxButton
        id="hpcr_regist_status"
        name="hpcr_regist_status"
        label="上記の利用規約、プライバシーポリシーに同意してヒポクラに同時登録する"
        value="1"
        :checked="hpcrStatus.flg"
        @call-input-change="editHpcrStatus($event.checked)"
        block
      />
    </div>

    <div v-if="$route.params.type === 'doctor_regist_flg'" class="h4_block">
      <DoctorRegister />
      <CheckboxButton
        id="doctor_regist_flg"
        name="doctor_regist_flg"
        label="上記の利用規約、プライバシーポリシーに同意してマイナビDOCTORに同時登録する"
        value="1"
        :checked="doctorRegist.flg"
        @call-input-change="editDoctorRegist($event.checked)"
        block
      />
    </div>

    <div v-if="$route.params.type === 'line'" class="h4_block">
      <HeadingLv4 text="LINEアカウントとの連携" />
      <p>
        LINEアカウントと連携すると、以降はLINEのアカウントでマイナビレジデントにログインできるようになります。<br />
        マイナビレジデントに登録してある会員情報は、LINEに登録してある情報で上書きされますのでご注意ください。
      </p>
      <SnsRegistButtons @click="toLine" label="LINEでログイン" />
    </div>

    <div v-if="$route.params.type === 'main_email_flg'">
      <FormRadioField
        label="メールマガジン配信"
        name="main_email_flg"
        :current-value="`${editableUserInfo.main_email_flg}`"
        :error="validations.main_email_flg.isError"
        :error-message="validations.main_email_flg.errorMessage"
        :items="main_email_flg"
        @change-value="editUserInfo('main_email_flg', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'member_type'">
      <FormRadioField
        label="現在の職種"
        name="member_type"
        :current-value="editableUserInfo.member_type"
        :error="validations.member_type.isError"
        :error-message="validations.member_type.errorMessage"
        :items="member_type"
        @change-value="editUserInfo('member_type', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'name'">
      <FormInputField
        label="姓"
        patternLabel="全角"
        placeholder="例：山田"
        name="name_sei"
        :value="editableUserInfo.name_sei"
        :error="validations.name_sei.isError"
        :error-message="validations.name_sei.errorMessage"
        @change-message="editUserInfo('name_sei', $event)"
        req
      />
      <FormInputField
        label="名"
        patternLabel="全角"
        placeholder="例：太郎"
        name="name_mei"
        :value="editableUserInfo.name_mei"
        :error="validations.name_mei.isError"
        :error-message="validations.name_mei.errorMessage"
        @change-message="editUserInfo('name_mei', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'name_kana'">
      <FormInputField
        label="セイ"
        patternLabel="全角"
        placeholder="例：ヤマダ"
        name="kana_sei"
        :value="editableUserInfo.kana_sei"
        :error="validations.kana_sei.isError"
        :error-message="validations.kana_sei.errorMessage"
        @change-message="editUserInfo('kana_sei', $event)"
        req
      />
      <FormInputField
        label="メイ"
        patternLabel="全角"
        placeholder="例：タロウ"
        name="kana_mei"
        :value="editableUserInfo.kana_mei"
        :error="validations.kana_mei.isError"
        :error-message="validations.kana_mei.errorMessage"
        @change-message="editUserInfo('kana_mei', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'gender'">
      <FormRadioField
        label="性別"
        name="gender"
        :current-value="editableUserInfo.gender"
        :error="validations.gender.isError"
        :error-message="validations.gender.errorMessage"
        :items="genders"
        @change-value="editUserInfo('gender', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'birthday'">
      <FormBirthDate
        name="birthday"
        label="生年月日"
        :value="editableUserInfo.birthday"
        :error="validations.birthday.isError"
        :error-message="validations.birthday.errorMessage"
        @selection-change="editUserInfo('birthday', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'email'">
      <FormInputField
        name="email"
        label="メールアドレス"
        patternLabel="半角英数"
        placeholder="例：abd@example.com"
        :value="editableUserInfo.email"
        :error="validations.email.isError"
        :error-message="validations.email.errorMessage"
        @change-message="editUserInfo('email', $event)"
        req
      />
      <FormInputField
        name="email_confirmation"
        label="メールアドレス(確認用)"
        patternLabel="半角英数"
        placeholder="例：abd@example.com"
        :value="editableUserInfo.email_confirmation"
        :error="validations.email_confirmation.isError"
        :error-message="validations.email_confirmation.errorMessage"
        @change-message="
          editConfirmField(
            { name: 'email_confirmation', target: editableUserInfo.email },
            $event
          )
        "
        req
      />
    </div>

    <div v-if="$route.params.type === 'address'">
      <div class="ttl -mb">
        <HeadingLv4 text="住所" />
        <LabelRequire />
      </div>

      <FormInputField
        name="zip"
        label="郵便番号"
        patternLabel="半角"
        placeholder="郵便番号7桁を入力（ハイフン無し）"
        description="＊郵便番号を入力すると住所が自動検索されます。"
        :value="editableUserInfo.zip"
        :error="validations.zip.isError"
        :error-message="validations.zip.errorMessage"
        @change-message="inputZip('zip', $event)"
        size="lg"
        formGroupReq
      />
      <FormSelectField
        id="prefecture"
        name="prefecture"
        label="都道府県"
        :value="editableUserInfo.prefecture"
        :error="validations.prefecture.isError"
        :error-message="validations.prefecture.errorMessage"
        :items="prefectures"
        @change-message="editUserInfo('prefecture', $event)"
        formGroupReq
      />
      <FormInputField
        label="市区町村"
        name="city"
        patternLabel="全角"
        placeholder="例：千代田区"
        :value="editableUserInfo.city"
        :error="validations.city.isError"
        :error-message="validations.city.errorMessage"
        @change-message="editUserInfo('city', $event)"
        formGroupReq
      />
      <FormInputField
        name="town"
        label="町名番地、建物等"
        patternLabel="全角"
        placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
        :value="editableUserInfo.town"
        :error="validations.town.isError"
        :error-message="validations.town.errorMessage"
        @change-message="editUserInfo('town', $event)"
        formGroupReq
      />
    </div>

    <div v-if="$route.params.type === 'tel'">
      <FormInputField
        label="電話番号"
        patternLabel=""
        placeholder="0000000000"
        name="telPhoneNumber"
        :value="editableUserInfo.tel"
        :error="validations.tel.isError"
        :error-message="validations.tel.errorMessage"
        @change-message="editUserInfo('tel', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'vacation_address'">
      <div class="ttl -mb">
        <HeadingLv4 text="休暇中住所" />
        <LabelRequire />
      </div>

      <FormFieldset>
        <CheckboxButtons
          name="diff_address"
          :items="[
            {
              label: '登録の住所と同じ',
              value: '1',
              id: 'diff_address',
              checked: editableUserInfo.vacation_flg,
              error: false
            }
          ]"
          style="white-space: nowrap"
          @change-checkbox="changeVacationAddressState"
        />
      </FormFieldset>

      <FormInputField
        label="郵便番号"
        patternLabel="半角"
        placeholder="郵便番号7桁を入力（ハイフン無し）"
        description="＊郵便番号を入力すると住所が自動検索されます。"
        :value="editableUserInfo.zip_vacation"
        :error="validations.zip_vacation.isError"
        :error-message="validations.zip_vacation.errorMessage"
        :disabled="state.disableVacationAddress"
        @change-message="inputZip('zip_vacation', $event)"
        size="lg"
        formGroupReq
      />
      <FormSelectField
        id="prefecture"
        name="prefecture"
        label="都道府県"
        :value="editableUserInfo.prefecture_vacation"
        :error="validations.prefecture_vacation.isError"
        :error-message="validations.prefecture_vacation.errorMessage"
        :items="prefectures"
        :disabled="state.disableVacationAddress"
        @change-message="editUserInfo('prefecture_vacation', $event)"
        formGroupReq
      />
      <FormInputField
        name="city_vacation"
        label="市区町村"
        patternLabel="全角"
        placeholder="例：千代田区"
        :value="editableUserInfo.city_vacation"
        :error="validations.city_vacation.isError"
        :error-message="validations.city_vacation.errorMessage"
        :disabled="state.disableVacationAddress"
        @change-message="editUserInfo('city_vacation', $event)"
        formGroupReq
      />
      <FormInputField
        name="town_vacation"
        label="町名番地、建物等"
        patternLabel="全角"
        placeholder="例：神田佐久間町1-33-3 〇〇マンション101号室"
        :value="editableUserInfo.town_vacation"
        :error="validations.town_vacation.isError"
        :error-message="validations.town_vacation.errorMessage"
        :disabled="state.disableVacationAddress"
        @change-message="editUserInfo('town_vacation', $event)"
        formGroupReq
      />
    </div>

    <div v-if="$route.params.type === 'school_id'">
      <FormSelectField
        name="school_id"
        label="大学名"
        :items="universities"
        :error="validations.school_id.isError"
        :error-message="validations.school_id.errorMessage"
        @change-message="editUserInfo('school_id', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'graduate_year'">
      <FormSelectField
        name="graduate_year"
        label="卒業時期（年）"
        :items="setYear('graduate')"
        :error="validations.graduate_year.isError"
        :error-message="validations.graduate_year.errorMessage"
        @change-message="editUserInfo('graduate_year', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'work_place'">
      <FormInputField
        name="work_place"
        label="現勤務先"
        patternLabel="全角"
        placeholder="例：〇〇病院"
        :value="editableUserInfo.work_place"
        :error="validations.work_place.isError"
        :error-message="validations.work_place.errorMessage"
        :disabled="false"
        @change-message="editUserInfo('work_place', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'licensing_year'">
      <FormSelectField
        name="licensing_year"
        label="医師免許取得年"
        :items="setYear()"
        :error="validations.licensing_year.isError"
        :error-message="validations.licensing_year.errorMessage"
        @change-message="editUserInfo('licensing_year', $event)"
        req
      />
    </div>

    <div v-if="$route.params.type === 'hope_prefectures'">
      <div class="ttl">
        <HeadingLv4 text="希望勤務地" />
        <LabelRequire />
      </div>
      <template v-for="(area, i) in areas" :key="i">
        <FormAreaCheckbox
          :id="`mypage_area${i}`"
          :label="area.name"
          :items="area.prefectures"
          @check-prefecture="editHopePrefecture(i, $event)"
        />
      </template>
    </div>

    <div v-if="$route.params.type === 'hope_keywords'">
      <div class="ttl">
        <HeadingLv4 text="希望するこだわり条件" />
        <LabelRequire />
      </div>
      <FormCheckboxButtons
        name="hopeKeywords"
        :items="keywords"
        @change-checkbox="editHopeKeywords"
      />
    </div>

    <div v-if="$route.params.type === 'hoped_diagnosis'">
      <FormSelectField
        label="第1希望"
        :items="hoped_diagnosis01"
        :error="validations.hoped_diagnosis01.isError"
        :error-message="validations.hoped_diagnosis01.errorMessage"
        @change-message="editHopeDiagnosis(0, $event)"
      />

      <FormSelectField
        label="第2希望"
        :items="hoped_diagnosis02"
        :error="validations.hoped_diagnosis02.isError"
        :error-message="validations.hoped_diagnosis02.errorMessage"
        @change-message="editHopeDiagnosis(1, $event)"
      />

      <FormSelectField
        label="第3希望"
        :items="hoped_diagnosis03"
        :error="validations.hoped_diagnosis03.isError"
        :error-message="validations.hoped_diagnosis03.errorMessage"
        @change-message="editHopeDiagnosis(2, $event)"
      />
    </div>

    <div class="buttons">
      <Button
        href="/mypage/user/profile"
        label="戻る"
        :handleClick="() => $router.go(-1)"
      />

      <Button
        v-if="$route.params.type !== 'line'"
        :label="`
        ${$route.params.type==='hpcr_regist_status' ||
        $route.params.type==='doctor_regist_flg'
        ? '追加登録する' : '変更内容を保存する'}`"
        primary
        :disabled="state.disableUpdateBtn"
        :handleClick="postEditUserProfile"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { reactive, onMounted, SetupContext } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import FormFieldset from '@/components/block/FormFieldset.vue'
import FormInputField from '@/components/block/FormInputField.vue'
import FormRadioField from '@/components/block/FormRadioField.vue'
import FormBirthDate from '@/components/block/FormBirthDate.vue'
import FormSelectField from '@/components/block/FormSelectField.vue'
import FormAreaCheckbox from '@/components/block/FormAreaCheckbox.vue'
import FormCheckboxButtons from '@/components/block/FormCheckboxButtons.vue'
import CheckboxButton from '@/components/elements/InputCheckboxButton.vue'
import CheckboxButtons from '@/components/block/FormCheckboxButtons.vue'
import HpcrRegister from '@/components/block/HpcrRegister.vue'
import DoctorRegister from '@/components/block/DoctorRegister.vue'
import HeadingLv4 from '@/components/elements/HeadingLv4.vue'
import Button from '@/components/elements/Button.vue'
import SnsRegistButtons from '@/components/block/SnsRegistButtons.vue'
import LabelRequire from '@/components/elements/LabelRequire.vue'
import { applyValidation } from '@/utils/validation'
import { axiosSetting } from '@/utils/axiosSetting'
import axios from 'axios'

export default {
  name: 'MyPageUserProfileEdit',

  components: {
    FormFieldset,
    FormInputField,
    FormRadioField,
    FormBirthDate,
    FormSelectField,
    FormAreaCheckbox,
    FormCheckboxButtons,
    CheckboxButton,
    CheckboxButtons,
    HpcrRegister,
    DoctorRegister,
    HeadingLv4,
    Button,
    SnsRegistButtons,
    LabelRequire
  },

  props: {
    formattedUserInfo: {
      type: Object,
      default: () => ({})
    }
  },

  setup(props: any, context: SetupContext) {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()

    // ------------------------------------------------------
    // 初期データセット
    // ------------------------------------------------------
    let editableUserInfo: Record<string, any> = reactive({})

    editableUserInfo = Object.assign({}, props.formattedUserInfo, {
      email_confirmation: props.formattedUserInfo.email
    })

    if (
      (route.params.type === 'hpcr_regist_status' &&
        props.formattedUserInfo.hpcr_regist_status) ||
      (route.params.type === 'line' &&
        props.formattedUserInfo.login_type === 'LINE')
    ) {
      router.replace('/500')
    }

    // ------------------------------------------------------
    // データ取得・セット
    // ------------------------------------------------------
    interface RadioObject {
      label: string
      value: string
      id: string
    }
    interface SelectObject {
      label: string
      value: string
      selected: boolean
    }
    interface AreaItem {
      label: string
      value: string
      id: string
      area: string
      checked?: boolean
    }
    interface CheckboxObject {
      label: string
      value: string
      id: string
      checked?: boolean
    }
    const selectDefault = {
      label: '選択してください',
      value: '',
      selected: false
    }

    // メールマガジン配信をセット
    const main_email_flg: Array<RadioObject> = reactive([
      {
        label: '配信を希望する',
        value: '1',
        id: 'main_email_flg1'
      },
      {
        label: '配信を希望しない',
        value: '2',
        id: 'main_email_flg2'
      }
    ])

    // 現在の職種をセット
    const member_type: Array<RadioObject> = reactive([])
    if (route.params.type === 'member_type') {
      store.state.master.memberType.forEach((el: any) => {
        if (el.opt_id === '0') return

        const item: RadioObject = {
          label: el.option_name,
          value: el.opt_id,
          id: 'memberType' + el.opt_id
        }
        member_type.push(item)
      })
    }

    // 性別をセット
    const genders: Array<RadioObject> = reactive([])
    if (route.params.type === 'gender') {
      store.state.master.gender.forEach((el: any) => {
        if (el.opt_id === '0') return

        const item: RadioObject = {
          label: el.option_name,
          value: el.opt_id,
          id: 'gender' + el.opt_id
        }
        genders.push(item)
      })
    }

    // 都道府県をセット
    const prefectures: Array<SelectObject> = reactive([selectDefault])
    if (
      route.params.type === 'address' ||
      route.params.type === 'vacation_address'
    ) {
      let selectedPref = 0

      if (route.params.type === 'address')
        selectedPref = editableUserInfo.prefecture || 0
      if (route.params.type === 'vacation_address')
        selectedPref = editableUserInfo.prefecture_vacation || 0

      store.state.master.prefectures.forEach((el: any) => {
        if (el.opt_id === '0') return

        const item: SelectObject = {
          label: el.option_name,
          value: el.opt_id,
          selected: selectedPref === el.option_name ? true : false
        }
        prefectures.push(item)
      })
    }

    // 大学をセット
    const universities: Array<SelectObject> = reactive([selectDefault])
    const selectedSchool = editableUserInfo.school_id || 0

    store.state.master.university.forEach((el: any) => {
      if (el.opt_id === '0') return

      const item: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedSchool === el.option_name ? true : false
      }
      universities.push(item)
    })

    // 年をセット
    const setYear = (type: string) => {
      const years: Array<SelectObject> = [selectDefault]
      const endSettingValue = type === 'graduate' ? 7 : 0
      const thisYear = new Date().getFullYear()
      const startYear = thisYear - 20
      const endYear = thisYear + endSettingValue

      let selectedYear = 0

      if (type === 'graduate') {
        selectedYear = editableUserInfo.graduate_year
          ? Number(editableUserInfo.graduate_year)
          : 0
      } else {
        selectedYear = editableUserInfo.licensing_year
          ? Number(editableUserInfo.licensing_year)
          : 0
      }

      for (let i = endYear; i >= startYear; i--) {
        years.push({
          label: i + '年',
          value: i + '',
          selected: i === selectedYear
        })
      }

      return years
    }

    // 希望エリアをセット
    const areas: Array<any> = reactive([])
    const checkedHopePrefectures: Array<number | string> = []
    const tempAreas: Array<string> = []
    const tempItems: Array<AreaItem> = []

    store.state.master.prefectures.forEach((el: any) => {
      if (el.opt_id === '0') return

      tempAreas.push(el.area)

      const checked =
        editableUserInfo.hope_prefectures.indexOf(el.option_name) > -1
      if (checked) {
        checkedHopePrefectures.push(el.opt_id)
      }

      const item: AreaItem = {
        label: el.option_name,
        value: el.opt_id,
        id: 'mypage_prefecture' + el.opt_id,
        area: el.area,
        checked: checked
      }
      tempItems.push(item)
    })

    const areaNames = Array.from(new Set(tempAreas))

    areaNames.forEach((area) => {
      const prefectures = tempItems.filter((item) => {
        return area === item.area
      })

      areas.push({
        name: area,
        prefectures: prefectures
      })
    })

    // 希望条件をセット
    const keywords: Array<CheckboxObject> = reactive([])
    const checkedHopekeywords: Array<number | string> = []

    store.state.master.keywords.forEach((el: any) => {
      if (el.opt_id === '0') return

      const checked =
        editableUserInfo.hope_keywords.indexOf(el.option_name) > -1
      if (checked) {
        checkedHopekeywords.push(el.opt_id)
      }

      const item: CheckboxObject = {
        label: el.option_name,
        value: el.opt_id,
        id: 'keywords' + el.opt_id,
        checked: checked
      }
      keywords.push(item)
    })

    // 希望科目をセット
    const hoped_diagnosis01: Array<SelectObject> = reactive([selectDefault])
    const hoped_diagnosis02: Array<SelectObject> = reactive([selectDefault])
    const hoped_diagnosis03: Array<SelectObject> = reactive([selectDefault])
    const checkedHopeDiagnosis: Array<number | string> = ['', '', '']
    const selectedHd01 =
      editableUserInfo.hoped_diagnosis && editableUserInfo.hoped_diagnosis[0]
        ? editableUserInfo.hoped_diagnosis[0]
        : 0
    const selectedHd02 =
      editableUserInfo.hoped_diagnosis && editableUserInfo.hoped_diagnosis[1]
        ? editableUserInfo.hoped_diagnosis[1]
        : 0
    const selectedHd03 =
      editableUserInfo.hoped_diagnosis && editableUserInfo.hoped_diagnosis[2]
        ? editableUserInfo.hoped_diagnosis[2]
        : 0

    store.state.master.departments.forEach((el: any) => {
      if (el.opt_id === '0') return

      if (selectedHd01) checkedHopeDiagnosis[0] = el.opt_id
      if (selectedHd02) checkedHopeDiagnosis[1] = el.opt_id
      if (selectedHd03) checkedHopeDiagnosis[2] = el.opt_id

      const item01: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd01 === el.option_name ? true : false
      }
      const item02: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd02 === el.option_name ? true : false
      }
      const item03: SelectObject = {
        label: el.option_name,
        value: el.opt_id,
        selected: selectedHd03 === el.option_name ? true : false
      }
      hoped_diagnosis01.push(item01)
      hoped_diagnosis02.push(item02)
      hoped_diagnosis03.push(item03)
    })

    // ------------------------------------------------------
    // バリデーション設定
    // ------------------------------------------------------
    const validations: Record<string, any> = reactive({
      member_type: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      main_email_flg: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      name_sei: {
        rules: ['required', 'max:500'],
        isError: false,
        errorMessage: ''
      },
      name_mei: {
        rules: ['required', 'max:500'],
        isError: false,
        errorMessage: ''
      },
      kana_sei: {
        rules: ['required', 'max:500', 'kana'],
        isError: false,
        errorMessage: ''
      },
      kana_mei: {
        rules: ['required', 'max:500', 'kana'],
        isError: false,
        errorMessage: ''
      },
      birthday: {
        rules: ['required', 'date'],
        isError: false,
        errorMessage: ''
      },
      gender: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      email: {
        rules: ['required', 'max:500', 'email'],
        isError: false,
        errorMessage: ''
      },
      email_confirmation: {
        rules: ['required', 'matchEmail'],
        isError: false,
        errorMessage: ''
      },
      zip: {
        rules: ['required', 'zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      city: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      town: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      tel: {
        rules: ['required', 'max:500', 'hankakueisu'],
        isError: false,
        errorMessage: ''
      },
      zip_vacation: {
        rules: ['required', 'zip'],
        isError: false,
        errorMessage: ''
      },
      prefecture_vacation: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      city_vacation: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      town_vacation: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      school_id: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      graduate_year: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      licensing_year: {
        rules: ['required', 'select'],
        isError: false,
        errorMessage: ''
      },
      work_place: {
        rules: ['required', 'max:255'],
        isError: false,
        errorMessage: ''
      },
      hoped_diagnosis01: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      hoped_diagnosis02: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      },
      hoped_diagnosis03: {
        rules: ['select'],
        isError: false,
        errorMessage: ''
      }
    })

    const hpcrStatus = reactive({
      flg: true
    })
    const doctorRegist = reactive({
      flg: true
    })

    // 変更ボタンの活性・非活性
    const checkDisableUpdate = (): boolean => {
      /* eslint-disable */
      if (route.params.type === 'hpcr_regist_status') {
        return hpcrStatus.flg === false ? true : false
      }

      if (route.params.type === 'doctor_regist_flg') {
        return doctorRegist.flg === false ? true : false
      }

      if (route.params.type === 'member_type') {
        return editableUserInfo.member_type === '' ? true : false
      }

      if (route.params.type === 'main_email_flg') {
        return editableUserInfo.main_email_flg === '' ? true : false
      }

      if (route.params.type === 'name') {
        return editableUserInfo.name_sei === '' ||
          editableUserInfo.name_mei === '' ||
          validations.name_sei.isError ||
          validations.name_mei.isError
          ? true
          : false
      }

      if (route.params.type === 'name_kana') {
        return editableUserInfo.kana_sei === '' ||
          editableUserInfo.kana_mei === '' ||
          validations.kana_sei.isError ||
          validations.kana_mei.isError
          ? true
          : false
      }

      if (route.params.type === 'gender') {
        return editableUserInfo.gender === '' ? true : false
      }

      if (route.params.type === 'birthday') {
        return editableUserInfo.birthday === '' || validations.birthday.isError
          ? true
          : false
      }

      if (route.params.type === 'email') {
        return editableUserInfo.email === '' ||
          editableUserInfo.email_confirmation === '' ||
          validations.email.isError ||
          validations.email_confirmation.isError
          ? true
          : false
      }

      if (route.params.type === 'address') {
        return !editableUserInfo.zip ||
          validations.zip.isError ||
          !editableUserInfo.prefecture ||
          validations.prefecture.isError ||
          !editableUserInfo.city ||
          validations.city.isError ||
          !editableUserInfo.town ||
          validations.town.isError
          ? true
          : false
      }

      if (route.params.type === 'tel') {
        return !editableUserInfo.tel || validations.tel.isError ? true : false
      }

      if (route.params.type === 'vacation_address') {
        return !editableUserInfo.vacation_flg &&
          (!editableUserInfo.zip_vacation ||
            !editableUserInfo.prefecture_vacation ||
            !editableUserInfo.city_vacation ||
            !editableUserInfo.town_vacation ||
            validations.zip_vacation.isError ||
            validations.prefecture_vacation.isError ||
            validations.city_vacation.isError ||
            validations.town_vacation.isError)
          ? true
          : false
      }

      if (route.params.type === 'school_id') {
        return editableUserInfo.school_id === '' ||
          validations.school_id.isError
          ? true
          : false
      }

      if (route.params.type === 'graduate_year') {
        return editableUserInfo.graduate_year === '' ||
          validations.graduate_year.isError
          ? true
          : false
      }

      if (route.params.type === 'work_place') {
        return editableUserInfo.work_place === '' ||
          validations.work_place.isError
          ? true
          : false
      }

      if (route.params.type === 'licensing_year') {
        return editableUserInfo.licensing_year === '' ||
          validations.licensing_year.isError
          ? true
          : false
      }

      if (route.params.type === 'hope_prefectures') {
        return checkedHopePrefectures.length === 0 ? true : false
      }

      if (route.params.type === 'hope_keywords') {
        return checkedHopekeywords.length === 0 ? true : false
      }

      if (route.params.type === 'hoped_diagnosis') {
        return validations.hoped_diagnosis01.isError ||
          validations.hoped_diagnosis02.isError ||
          validations.hoped_diagnosis03.isError
          ? true
          : false
      }
      /* eslint-enable */

      return false
    }

    const state = reactive({
      disableUpdateBtn: checkDisableUpdate(),
      disableVacationAddress: editableUserInfo['vacation_flg']
    })

    // ヒポクラの同意ボタンチェック
    const editHpcrStatus = (checked: boolean) => {
      hpcrStatus.flg = checked
      state.disableUpdateBtn = checkDisableUpdate()
    }
    // ヒポクラの同意ボタンチェック
    const editDoctorRegist = (checked: boolean) => {
      doctorRegist.flg = checked
      state.disableUpdateBtn = checkDisableUpdate()
    }

    // Eメール確認用
    const editConfirmField = (obj: Record<string, string>, value: string) => {
      editableUserInfo[obj.name] = value

      const rules = validations[obj.name].rules
      const arr: Array<string> = []
      for (let i = 0; i < rules.length; i++) {
        if (rules[i] === 'matchEmail') {
          arr.push('matchEmail:' + obj.target)
        } else {
          arr.push(rules[i])
        }
      }
      const result = applyValidation(arr, value)
      validations[obj.name].isError = result.isError
      validations[obj.name].errorMessage = result.message
      state.disableUpdateBtn = checkDisableUpdate()
    }

    const editUserInfo = (name: string, value: string) => {
      editableUserInfo[name] = value
      console.log(editableUserInfo)

      const result = applyValidation(validations[name].rules, value)

      validations[name].isError = result.isError
      validations[name].errorMessage = result.message

      state.disableUpdateBtn = checkDisableUpdate()

      if (name === 'email' && editableUserInfo.email_confirmation) {
        editConfirmField(
          { name: 'email_confirmation', target: editableUserInfo.email },
          editableUserInfo.email_confirmation
        )
      }
    }

    const getAddressFromZipCode = (name: string, value: string) => {
      const zip1 = value.substr(0, 3)
      const zip2 = value.substr(3, 4)

      axios
        .get(
          `https://madefor.github.io/postal-code-api/api/v1/${zip1}/${zip2}.json`
        )
        .then((res) => {
          let selectedPref = 0

          for (let i = 0; i < prefectures.length; i++) {
            if (
              Number(res.data.data[0].prefcode) === Number(prefectures[i].value)
            ) {
              selectedPref = i
            }
          }

          if (name === 'zip') {
            prefectures[selectedPref].selected = true
            editableUserInfo['prefecture'] = prefectures[selectedPref].value
            editableUserInfo['city'] = res.data.data[0].ja.address1
            editableUserInfo['town'] = res.data.data[0].ja.address2
            const city: any = document.querySelector('input[name="city"]')
            if (city) city.value = res.data.data[0].ja.address1
            const town: any = document.querySelector('input[name="town"]')
            if (town) town.value = res.data.data[0].ja.address2
            editUserInfo('prefecture', prefectures[selectedPref].value)
            editUserInfo('city', res.data.data[0].ja.address1)
            editUserInfo('town', res.data.data[0].ja.address2)
          }
          if (name === 'zip_vacation') {
            prefectures[selectedPref].selected = true
            editableUserInfo['prefecture_vacation'] =
              prefectures[selectedPref].value
            editableUserInfo['city_vacation'] = res.data.data[0].ja.address1
            editableUserInfo['town_vacation'] = res.data.data[0].ja.address2
            const city: any = document.querySelector(
              'input[name="city_vacation"]'
            )
            if (city) city.value = res.data.data[0].ja.address1
            const town: any = document.querySelector(
              'input[name="town_vacation"]'
            )
            if (town) town.value = res.data.data[0].ja.address2
            editUserInfo('prefecture_vacation', prefectures[selectedPref].value)
            editUserInfo('city_vacation', res.data.data[0].ja.address1)
            editUserInfo('town_vacation', res.data.data[0].ja.address2)
          }
        })
    }

    const inputZip = (name: string, value: string) => {
      editUserInfo(name, value)

      if (/^[0-9]{7}$/.test(value)) {
        getAddressFromZipCode(name, value)
      }
    }

    const changeVacationAddressState = (ev: Record<string, boolean>) => {
      editableUserInfo['vacation_flg'] = ev.checked

      state.disableVacationAddress = ev.checked

      if (ev.checked) {
        validations.zip_vacation.isError = false
        validations.zip_vacation.errorMessage = ''
        validations.prefecture_vacation.isError = false
        validations.prefecture_vacation.errorMessage = ''
        validations.city_vacation.isError = false
        validations.city_vacation.errorMessage = ''
        validations.town_vacation.isError = false
        validations.town_vacation.errorMessage = ''
      }

      state.disableUpdateBtn = checkDisableUpdate()
    }

    const editHopePrefecture = (index: number, prefecture: any) => {
      areas[index].prefectures.forEach((item: AreaItem) => {
        if (prefecture.value === item.value) item.checked = prefecture.checked
      })

      if (
        prefecture.checked &&
        checkedHopePrefectures.indexOf(prefecture.value) === -1
      ) {
        checkedHopePrefectures.push(prefecture.value)
      }

      if (
        !prefecture.checked &&
        checkedHopePrefectures.indexOf(prefecture.value) > -1
      ) {
        checkedHopePrefectures.splice(
          checkedHopePrefectures.indexOf(prefecture.value),
          1
        )
      }

      state.disableUpdateBtn = checkDisableUpdate()
    }

    const editHopeKeywords = (keyword: any) => {
      if (
        keyword.checked &&
        checkedHopekeywords.indexOf(keyword.value) === -1
      ) {
        checkedHopekeywords.push(keyword.value)
      }

      if (!keyword.checked && checkedHopekeywords.indexOf(keyword.value) > -1) {
        checkedHopekeywords.splice(
          checkedHopekeywords.indexOf(keyword.value),
          1
        )
      }

      state.disableUpdateBtn = checkDisableUpdate()
    }

    const editHopeDiagnosis = (index: number, value: string) => {
      checkedHopeDiagnosis[index] = value

      state.disableUpdateBtn = checkDisableUpdate()
    }

    /*
     * 送信処理
     */
    const editUser = axiosSetting('app', 'block')
    const postEditUserProfile = () => {
      const setPostUrl = () => {
        if (route.params.type === 'hpcr_regist_status') {
          return '/api/v1/hipokura_entry'
        }
        if (route.params.type === 'line') {
          return '/api/v1/line_entry'
        }
        return '/api/v1/user_mypage/edit'
      }
      const postUrl = setPostUrl()

      store.commit('showLoading')
      const params: Record<string, any> = {}

      if (route.params.type === 'line') {
        const urlParams: any = new URLSearchParams(location.search)
        params.token = urlParams.get('token')
      }

      if (route.params.type === 'main_email_flg') {
        params.main_email_flg = Number(editableUserInfo.main_email_flg)
      }

      if (route.params.type === 'member_type') {
        params.member_type = editableUserInfo.member_type
      }

      if (route.params.type === 'name') {
        params.name_sei = editableUserInfo.name_sei
        params.name_mei = editableUserInfo.name_mei
      }

      if (route.params.type === 'name_kana') {
        params.kana_sei = editableUserInfo.kana_sei
        params.kana_mei = editableUserInfo.kana_mei
      }

      if (route.params.type === 'gender') {
        params.gender = editableUserInfo.gender
      }

      if (route.params.type === 'birthday') {
        params.birthday = editableUserInfo.birthday
      }

      if (route.params.type === 'email') {
        params.email = editableUserInfo.email
      }

      if (route.params.type === 'address') {
        params.zip = editableUserInfo.zip
        params.prefecture = editableUserInfo.prefecture
        params.city = editableUserInfo.city
        params.town = editableUserInfo.town
      }

      if (route.params.type === 'tel') {
        params.tel = editableUserInfo.tel
      }

      if (route.params.type === 'vacation_address') {
        params.vacation_flg = editableUserInfo.vacation_flg

        if (!editableUserInfo.vacation_flg) {
          params.zip_vacation = editableUserInfo.zip_vacation
          params.prefecture_vacation = editableUserInfo.prefecture_vacation
          params.city_vacation = editableUserInfo.city_vacation
          params.town_vacation = editableUserInfo.town_vacation
        }
      }

      if (route.params.type === 'school_id') {
        params.school_id = editableUserInfo.school_id
      }

      if (route.params.type === 'graduate_year') {
        params.graduate_year = editableUserInfo.graduate_year
      }

      if (route.params.type === 'work_place') {
        params.work_place = editableUserInfo.work_place
      }

      if (route.params.type === 'licensing_year') {
        params.licensing_year = editableUserInfo.licensing_year
      }

      if (route.params.type === 'hope_prefectures') {
        params.hope_prefectures = checkedHopePrefectures
      }

      if (route.params.type === 'hope_keywords') {
        params.hope_keywords = checkedHopekeywords
      }

      if (route.params.type === 'hoped_diagnosis') {
        params.hoped_diagnosis = checkedHopeDiagnosis
      }

      if (route.params.type === 'doctor_regist_flg') {
        params.doctor_regist_flg = 1
      }

      editUser
        .post(postUrl, params)
        .then((res) => {
          // @TODO FBだす
          if (
            route.params.type === 'address' ||
            route.params.type === 'vacation_address'
          ) {
            // テキスト系更新
            context.emit('update-edit-info', params)

            // セレクトとチェックボックス更新
            const targetParam =
              route.params.type === 'address'
                ? 'prefecture'
                : 'prefecture_vacation'
            let prefecture = ''
            store.state.master.prefectures.forEach((el: any) => {
              if (el.opt_id == params[targetParam]) {
                prefecture = el.option_name
              }
            })
            if (route.params.type === 'address') {
              context.emit('update-edit-info', {
                prefecture: prefecture
              })
            }
            if (route.params.type === 'vacation_address') {
              const obj: any = {
                vacation_flg: params.vacation_flg
              }
              if (prefecture) {
                obj.prefecture_vacation = prefecture
              }
              context.emit('update-edit-info', obj)
            }
          } else if (route.params.type === 'hope_prefectures') {
            const arr: any = []
            store.state.master.prefectures.forEach((el: any) => {
              if (checkedHopePrefectures.indexOf(el.opt_id) > -1)
                arr.push(el.option_name)
            })
            context.emit('update-edit-info', {
              hope_prefectures: arr
            })
          } else if (route.params.type === 'hope_keywords') {
            const arr: any = []
            store.state.master.keywords.forEach((el: any) => {
              if (checkedHopekeywords.indexOf(el.opt_id) > -1)
                arr.push(el.option_name)
            })
            context.emit('update-edit-info', {
              hope_keywords: arr
            })
          } else if (route.params.type === 'hoped_diagnosis') {
            const arr: any = []
            store.state.master.departments.forEach((el: any) => {
              if (checkedHopeDiagnosis[0] === el.opt_id) arr[0] = el.option_name
              if (checkedHopeDiagnosis[1] === el.opt_id) arr[1] = el.option_name
              if (checkedHopeDiagnosis[2] === el.opt_id) arr[2] = el.option_name
            })
            context.emit('update-edit-info', {
              hoped_diagnosis: arr
            })
          } else if (route.params.type === 'school_id') {
            let schoolName = ''
            store.state.master.university.forEach((el: any) => {
              if (el.opt_id === params.school_id) schoolName = el.option_name
            })

            context.emit('update-edit-info', {
              school_id: schoolName
            })
          } else {
            context.emit('update-edit-info', params)
          }

          // 裏でStoreのユーザー情報アップデート
          store.dispatch('getUserInfo')

          const getUserInfo = axiosSetting('app', 'action')
          getUserInfo
            .get('/api/v1/userInfo?is_all=1')
            .then((res) => {
              // Storeのユーザー情報アップデート
              store.commit('setUserInfo', res.data)
              // ユーザー情報確認ページの情報を更新
              context.emit('update-user-info', res.data)
              router.push('/mypage/user/profile')
            })
            .catch((err) => {
              store.commit('showSystemError', 'modal')
            })
            .then(() => {
              store.commit('closeLoading')
            })
        })
        .catch((err) => {
          try {
            if (err.response.status === 422) {
              const errors = err.response.data[0]
              if (
                route.params.type === 'hope_prefectures' ||
                route.params.type === 'hope_keywords'
              ) {
                alert('必須項目が選択されていません')
                store.commit('closeLoading')
                return
              } else if (route.params.type === 'line') {
                alert(err.response.data.err_msg)
                store.commit('closeLoading')
                return
              } else {
                Object.keys(errors).forEach((key: string) => {
                  validations[key].isError = true
                  validations[key].errorMessage = errors[key][0]
                })
                store.commit('closeLoading')
                return
              }
            }
            store.commit('showSystemError', 'modal')
            store.commit('closeLoading')
          } catch (e) {
            console.log(e)
            store.commit('showSystemError', 'modal')
            store.commit('closeLoading')
          }
        })
    }

    /*
     * LINE連携処理
     */
    const toLine = () => {
      location.href = `https://ca68f31f7a.auth.socialplus.jp/mynavi_resident/mynavi_resident_usr/line/authenticate?callback=${process.env.VUE_APP_URL}/mypage/user/profile/line`
    }
    onMounted(async () => {
      const urlParams = new URLSearchParams(location.search)
      const token = urlParams.get('token')
      if (token) {
        postEditUserProfile()
      }
    })

    return {
      main_email_flg,
      member_type,
      genders,
      prefectures,
      universities,
      setYear,
      areas,
      editHopePrefecture,
      keywords,
      editHopeKeywords,
      hoped_diagnosis01,
      hoped_diagnosis02,
      hoped_diagnosis03,
      editHopeDiagnosis,
      validations,
      state,
      hpcrStatus,
      editHpcrStatus,
      doctorRegist,
      editDoctorRegist,
      editableUserInfo,
      editUserInfo,
      editConfirmField,
      inputZip,
      changeVacationAddressState,
      toLine,
      postEditUserProfile
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.h4_block {
  margin-top: -30px;
}

.ttl {
  margin-top: -30px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  &.-mb {
    margin-bottom: 20px;
  }
}

.buttons {
  display: flex;
  justify-content: center;
  margin: 45px -16px 0;
  padding: 10px 8px;
  background-color: #f5f5f5;

  @include mixins.media() {
    margin: 70px 0 0;
    background-color: transparent;
  }

  .button {
    margin: 0 4px;

    @include mixins.media() {
      margin: 0 8px;
    }
  }
}
</style>
